/* eslint-disable no-unused-vars */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';


import { IoCloseCircleSharp } from "react-icons/io5";
import config from '../../config';

//https://www.google.com/search?q=react+create+component+to+show+image+in+modal&rlz=1C1RXQR_enUS1188US1188&sourceid=chrome&ie=UTF-8&udm=50&aep=48&cud=1&qsubts=1767820952680&mtid=xc5eadHEEdis5NoP0fiVgA0&mstk=AUtExfD3p-_3FwF7K2bllXz5YKD1p0XR1WjtiZWxgixbfPnsO-NXbZAO-zFNL__XlMjQOmVj0iuRKjOY5EoJTXlcILSqoAFt7sqkpIr5hbsSIpel5ekN4O__Th4C5OfEtX73IR-2YjANaH5pI4grX73o28pSeu7QPX5XaxmF7E9G3r_LwZ6Lkb_0d5OYlpsUd2J5tRGqLGjvh2xH_gkAaplwg6fdHFSyb4g2szdljd9OzamjUPjN1hIHgE7I2_40cCDJTQCYCUWdd4BJpX-JjHvW9FZ_PkwjomlnnGrXAkppJFlMD_kT4VSsEvgnWA9Ud-BIbh-sdyGnxaqGA_bEnxQE8jWEfWWstGyC3Q&csuir=1
//create react component to show image in modal

//w-[80%] h-[200px] overflow-y-auto
// &times; X to close
// ImageModal.js

const ImageModal = ({ src, alt, onClose, title }) => {
  const sellerFrontendURL = config.STR_FRONTEND_URL
  const { seller } = useSelector(state => state.seller)
  const { userInfo } = useSelector(state => state.auth)
  
  const sellerId = seller._id 
  const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
  const sellerSecondaryColor1 = seller.frontEndSecondaryColor1

  if (!src) return null;
    
    
  return (
    <div style={styles.overlay} onClick={onClose}>
      <div className='' style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className='border-2 p-3' 
          style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
          <div className='text-center'
            style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
            {title && <h2 className='font-bold text-xl'>{title}</h2>}
          </div>
          <button style={styles.closeBtn} onClick={onClose}  
            className='2xs:h-[34px] 2xs:w-[34px] 2xs:text-[20px] xs:h-[34px] xs:w-[34px] xs:text-[20px] 
            sm:h-[34px] sm:w-[34px] sm:text-[20px] md:h-[34px] md:w-[34px] md:text-[20px] 
            lg:h-[44px] lg:w-[44px] lg:text-[30px] xl:h-[44px] xl:w-[44px] xl:text-[30px] 
            2xl:h-[44px] 2xl:w-[44px] 2xl:text-[30px] 3xl:h-[44px] 3xl:w-[44px] 3xl:text-[30px] 
            4xl:h-[44px] 4xl:w-[44px] 4xl:text-[30px] 
            cursor-pointer' >
            <IoCloseCircleSharp />
          </button>
          <div className='w-[90%] h-[400px] overflow-y-auto' >
              <img src={src} alt={alt} style={styles.image} />
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  //height: '44px', width: '44px', fontSize: '30px', 
  closeBtn: { position: 'absolute', top: '40px', marginRight: '10px', paddingLeft: '6px', right: '0', 
    color: 'red', background: 'white', border: '1px solid red', cursor: 'pointer' },

  overlay: {
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
    backgroundColor: 'rgba(7, 40, 0, 0.32)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
  },
  modal: { position: 'relative', maxWidth: '90%', maxHeight: '90%',  border: '0px solid purple', },
  
  image: { width: '99%', height: 'auto', borderRadius: '8px' },
  
  
};

// const styles = {
//   overlay: {
//     position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
//     backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
//   },
//   modal: { position: 'relative', maxWidth: '90%', maxHeight: '90%' },
//   image: { width: '99%', height: 'auto', borderRadius: '8px' },
//   closeBtn: { position: 'absolute', top: '-40px', right: '0', fontSize: '30px', 
//     color: 'white', background: 'none', border: 'none', cursor: 'pointer' }
// };

export default ImageModal;
